import { InfiniteLandingHeroPage } from '../components/InfiniteLandingHeroPage'
import { InfiniteLandingInsights } from '../components/InfiniteLandingInsights'
import { InfiniteLandingKeyFeatures } from '../components/InfiniteLandingKeyFeatures'
import { InfiniteLandingBenefits } from '../components/InfiniteLandingBenefits'
import { InfiniteLandingTestimonials } from '../components/InfiniteLandingTestimonials'
import { InfiniteLandingTrustStatement } from '../components/InfiniteLandingTrustStatement'
import { InfiniteLandingFaqAccordion } from '../components/InfiniteLandingFaqAccordion'
import { useInfiniteLandingPageState } from '../hooks/useInfiniteLandingPageState'
import { useEffect } from 'react'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'

export const InfiniteLandingPage = () => {
  const {
    topPadding,
    bottomPadding,
    firstFoldMinHeight,
    heroVariant,
    userFirstName,
    isInitialLoading,
    onJoinWaitlistSuccess,
    onboardingStatus
  } = useInfiniteLandingPageState()

  useEffect(() => {
    trackEvent({
      eventName: EventNames.ScreenLoaded,
      payload: {
        screenType: 'MF_Infinite_Landing'
      }
    })
  }, [])

  if (isInitialLoading) {
    return (
      <div
        className='h-[100dvh] w-full overflow-hidden bg-black'
        style={{ paddingTop: `${topPadding}px`, paddingBottom: `${bottomPadding}px` }}
      />
    )
  }

  return (
    <div
      className='h-[100dvh] w-full overscroll-none overflow-x-hidden overflow-y-auto bg-black no-scrollbar'
      style={{ paddingTop: `${topPadding}px` }}
    >
      <div className='mx-auto bg-black font-libre-franklin'>
        <InfiniteLandingHeroPage
          variant={heroVariant}
          primaryUserName={userFirstName}
          firstFoldMinHeight={firstFoldMinHeight}
          onJoinWaitlistSuccess={onJoinWaitlistSuccess}
        />
        <InfiniteLandingInsights onboardingStatus={onboardingStatus} />
        <InfiniteLandingKeyFeatures />
        <InfiniteLandingBenefits />
        <InfiniteLandingTestimonials />
        <InfiniteLandingTrustStatement onboardingStatus={onboardingStatus} />
        <InfiniteLandingFaqAccordion heroVariant={heroVariant} />
      </div>
    </div>
  )
}
